import urlJoin from "url-join";

export const creditSection = "/credit/";

export const creditOverviewPath = urlJoin(creditSection, "overview");
export const creditOverviewUrl = creditOverviewPath;

export const bankListPath = urlJoin(creditSection, "banks") + "/";
export const bankListUrl = bankListPath;

export const bankPath = (id: string) => urlJoin(creditSection, "banks", id);
export const bankUrl = (id: string) => bankPath(encodeURIComponent(id));

export const applicationListPath = urlJoin(creditSection, "applications") + "/";
export const applicationListUrl = applicationListPath;

export const accountListPath = urlJoin(creditSection, "accounts") + "/";
export const accountListUrl = accountListPath;
